import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import type { PersonalViewState } from "./usePersonalView";
import { useDebouncedValue } from "./useDebouncedValue";

/** Only user typing changes the URL/preference; hydration and Back never write. */
export function useViewSearch(view: PersonalViewState) {
  const location = useLocation();
  const value = view.params.get("q") ?? "";
  const [draft, setDraft] = useState(value);
  const dirty = useRef(false);
  const debounced = useDebouncedValue(draft, 200).trim();
  useEffect(() => { dirty.current = false; setDraft(value); }, [value, location.key]);
  useEffect(() => {
    if (!view.ready || !dirty.current || draft.trim() !== debounced || value === debounced) return;
    const next = new URLSearchParams(view.params);
    if (debounced) next.set("q", debounced); else next.delete("q");
    dirty.current = false;
    view.change(next, { replace: true });
  }, [debounced, draft, value, view.params, view.change, view.ready]);
  return { search: draft, setSearch: (next: string) => { if (view.ready) { dirty.current = true; setDraft(next); } }, searchPending: draft.trim() !== value };
}
